import {createReducer, createAsyncThunk} from '@reduxjs/toolkit'
import AppLabelsProps from '../../props_reusable/labels'
import labelsService from '../../services/labels.service'
import utils from '../../utils'

interface FetchLabelsProp {
  orderGUID: string
  languageCode: string
}

const initialState = {} as AppLabelsProps

export const fetchLabels = createAsyncThunk(
  'fetchLabels',
  ({orderGUID, languageCode}: FetchLabelsProp) => {
    return labelsService
      .getLabels<AppLabelsProps>(orderGUID, languageCode)
      .catch(utils.routeToErrorPage)
  },
)

const labelsReducer = createReducer(initialState, builder => {
  builder.addCase(fetchLabels.fulfilled, (state, action) => {
    return action.payload
  })
})

export default labelsReducer
